import ApiCall from 'services/ApiCall'

const adjustmentService = ApiCall._generateCrud('account.adjustment')

export default adjustmentService
